import { Component, Input, Output, OnChanges, EventEmitter } from "@angular/core";

@Component({
    selector: "ng-marketplace-v2-guardrail",
    templateUrl: "./ng-marketplace-v2-guardrail.component.html",
    styleUrls: ["./ng-marketplace-v2-guardrail.component.less"]
})
export class NgMarketplaceV2GuardrailComponent implements OnChanges {
    @Input() showBeforeUpgrade: boolean;
    @Input() showBeforeUpdate: boolean;
    @Input() isPrivate: boolean;

    @Output() agreed: EventEmitter<null> = new EventEmitter();
    @Output() cancel: EventEmitter<null> = new EventEmitter();

    visible = false;

    ngOnChanges() {
        this.visible = this.showBeforeUpgrade || this.showBeforeUpdate;
    }

    emitAgreed() {
        this.agreed.emit();
        this.visible = false;
    }

    emitCancel() {
        this.cancel.emit();
        this.visible = false;
    }
}
